import React from 'react';
import { TicketFormBaseInputsBlock } from './blocks/ticket-form-base-inputs-block';
import { TicketFormComplementaryInputsBlock } from './blocks/ticket-form-complementary-inputs-block';
import { TicketFormErrorInfoBlock } from './blocks/ticket-form-error-info-block';

const TicketFormBody = ({ ticketFormBodyData }) => {
  const { backendErrors } = ticketFormBodyData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;
  let backendErrorsMsg = 'There was an error creating the ticket';
  if (backendErrors.details === 'can_not_reach_backend')
    backendErrorsMsg = 'There was an error connecting to the server';
  return (
    <>
      <TicketFormBaseInputsBlock ticketFormBodyData={ticketFormBodyData} />
      <TicketFormComplementaryInputsBlock
        ticketFormBodyData={ticketFormBodyData}
      />
      {hasBackendErrors && (
        <TicketFormErrorInfoBlock backendErrorsMsg={backendErrorsMsg} />
      )}
    </>
  );
};

export default TicketFormBody;
